import { useState } from 'react';

const useScrollContainer = (containerNode: React.MutableRefObject<HTMLDivElement | null>) => {
  const [boxTopPosition, setBoxTopPosition] = useState<null | number>(null);
  const [offset, setOffset] = useState<null | number>(null);

  const addEventListener = () => {
    window.addEventListener('scroll', checkHeight);
  };

  const removeEventListener = () => {
    window.removeEventListener('scroll', checkHeight);
  };

  const checkHeight = () => {
    const node = containerNode.current;
    if (node) {
      const rect = node.getBoundingClientRect();
      const tmpBoxTopPosition = rect.top + rect.height + 55;
      const tmpOffset = rect.top;
      if (boxTopPosition !== tmpBoxTopPosition) {
        setBoxTopPosition(tmpBoxTopPosition);
      }
      if (tmpOffset !== offset) {
        setOffset(tmpOffset);
      }
    }
  };

  return {
    addEventListener,
    removeEventListener,
    boxTopPosition,
    checkHeight,
    offset,
  };
};

export default useScrollContainer;
